(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-premium-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHero(root) {
    if (!root || root.getAttribute('data-hp-hero-init') === '1') return;
    root.setAttribute('data-hp-hero-init', '1');

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hp-hero-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hp-hero-dot]'));
    var prevBtn = root.querySelector('[data-hp-hero-prev]');
    var nextBtn = root.querySelector('[data-hp-hero-next]');
    if (slides.length < 2) return;

    var ms = parseInt(root.getAttribute('data-autoplay-ms'), 10) || 5000;
    var idx = 0;
    var touchStartX = null;
    var touchStartY = null;
    var timer;

    function go(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === idx);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
        d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
    }

    function restart() {
      clearInterval(timer);
      if (ms < 1000) return;
      timer = setInterval(function () {
        go(idx + 1);
      }, ms);
    }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        go(i);
        restart();
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        go(idx - 1);
        restart();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        go(idx + 1);
        restart();
      });
    }

    root.addEventListener(
      'touchstart',
      function (e) {
        if (e.touches.length !== 1) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      },
      { passive: true }
    );

    root.addEventListener(
      'touchend',
      function (e) {
        if (touchStartX == null || e.changedTouches.length !== 1) return;
        var x = e.changedTouches[0].clientX;
        var y = e.changedTouches[0].clientY;
        var dx = x - touchStartX;
        var dy = y - touchStartY;
        touchStartX = null;
        touchStartY = null;
        if (Math.abs(dx) < 52) return;
        if (Math.abs(dx) < Math.abs(dy) * 1.15) return;
        if (dx < 0) go(idx + 1);
        else go(idx - 1);
        restart();
      },
      { passive: true }
    );

    restart();
  }

  function boot() {
    document.querySelectorAll('[data-hp-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
